import { useMemo, useRef } from 'react'
import { useColorContext } from '../../context/ColorContext'
import './PreviewColors.scss'

export default function PreviewColors() {
	const { colors } = useColorContext()
	const columnCount = 9
	const cardsPerColumn = 3
	const totalCards = columnCount * cardsPerColumn

	// Випадкові постійні висоти (генеруються лише 1 раз)
	const fixedHeightsRef = useRef(
		Array.from({ length: totalCards }, () => {
			const min = 200
			const max = 320
			const randomPx = Math.random() * (max - min) + min
			return `${randomPx.toFixed(2)}px`
		})
	)

	// Випадкові відступи зверху для колонок (один раз)
	const columnOffsets = useMemo(() => {
		return Array.from(
			{ length: columnCount },
			() => `${Math.floor(Math.random() * 44)}px`
		)
	}, [])

	// 9 колонок по 3 кольори
	const columns = Array.from({ length: columnCount }, (_, i) =>
		colors.slice(i * cardsPerColumn, i * cardsPerColumn + cardsPerColumn)
	)

	return (
		<div className='preview'>
			<div className='preview__wrapper'>
				<div className='preview__flex'>
					{columns.map((col, colIndex) => (
						<div
							className='preview__column'
							key={colIndex}
							style={{ marginTop: columnOffsets[colIndex] }}
						>
							{col.map((color, i) => {
								const delay = (colIndex + i * 0.3) * 200
								const globalIndex = colIndex * cardsPerColumn + i
								return (
									<div
										className='preview__color'
										key={i}
										style={{
											backgroundColor: color,
											height: fixedHeightsRef.current[globalIndex],
											animationDelay: `${delay}ms`,
										}}
									/>
								)
							})}
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
